export const BASE_URL = 'https://amenityscores.com/backend_api/';
// export const BASE_URL = 'http://localhost:8000/';